import { getFormattedAmount } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import React from "react";

const ChequeDetails = ({ psid, chequeNumber, chequeAmount, chequeDate }) => {
  return (
    <div>
      <div className="d-flex justify-content-between regular-body mb-2">
        <div>PSID</div>
        <div className="text-dark text-bold">{psid}</div>
      </div>
      <div className="d-flex justify-content-between regular-body mb-2">
        <div>Cheque/DD number</div>
        <div className="text-dark text-bold">{chequeNumber}</div>
      </div>
      <div className="d-flex justify-content-between regular-body mb-2">
        <div>Cheque/DD amount</div>
        <div className=" text-dark text-bold"> {getFormattedAmount(chequeAmount)}</div>
      </div>
      <div className="d-flex justify-content-between regular-body mb-2">
        <div>Cheque/DD date</div>
        <div className=" text-dark text-bold">{chequeDate || ""}</div>
      </div>
    </div>
  );
};

export default ChequeDetails;
